import { ResultEntry } from '../search/ResultEntry';

export enum Referrer {
  List,
  Details
}

export interface RouteTargetEntry extends ResultEntry {
  referrer: Referrer;
}

export interface RouteRequest {
  referrer: Referrer;
  entry: ResultEntry;
}
